export default __webpack_public_path__ + "static/media/marcas.040eeb7c.png";